import axios from "axios";

export interface CommunityOption {
  id: string;
  label: string;
}

export interface CommunityQuestion {
  id: string;
  label: string;
  prompt: string;
  guidance: string;
  options: CommunityOption[];
}

export interface CommunityQuestionSelection {
  context_id: string;
  question: CommunityQuestion;
}

export interface CommunityQuestionCatalog {
  context_id: string;
  questions: CommunityQuestion[];
}

export interface CommunityObservationInput {
  context_id: string;
  question_id: string;
  answer: string;
  observed_at: string;
  place_confirmed: boolean;
  location_accessed: boolean;
  latitude?: number;
  longitude?: number;
  idempotency_key: string;
}

export interface CommunityObservationResponse {
  id: string;
  context_id: string;
  question_id: string;
  answer: string;
  observed_at: string;
  submitted_at: string;
  place_confirmed: boolean;
  location_accessed: boolean;
  location_verified: boolean;
  confidence: "high" | "medium";
  idempotency_key: string;
  source: string;
  topic: string;
  status: "published";
}

const apiBase = process.env.REACT_APP_API_HOST ?? "";
const apiTimeout = 30000;

export async function getCommunityQuestion(contextId: string): Promise<CommunityQuestionSelection> {
  const response = await axios.get<CommunityQuestionSelection>(
    `${apiBase}/api/v1/community/questions`,
    {
      params: { context_id: contextId },
      timeout: apiTimeout,
    },
  );
  return response.data;
}
export async function getCommunityQuestions(contextId: string): Promise<CommunityQuestionCatalog> {
  const response = await axios.get<CommunityQuestionCatalog>(
    `${apiBase}/api/v1/community/questions/all`,
    {
      params: { context_id: contextId },
      timeout: apiTimeout,
    },
  );
  return response.data;
}

export async function submitCommunityObservation(
  input: CommunityObservationInput,
): Promise<CommunityObservationResponse> {
  const response = await axios.post<CommunityObservationResponse>(
    `${apiBase}/api/v1/community/observations`,
    input,
    { timeout: apiTimeout },
  );
  return response.data;
}
